import clsx from 'clsx'
import { FC, ReactNode } from 'react'
import { Typography } from '@mui/material'
import styles from './style.module.scss'

interface IProps {
  status?: 'default' | 'success' | 'error'
  showMessage?: boolean
  children?: ReactNode
  className?: string
}

export const Message: FC<IProps> = ({
  status = 'default',
  showMessage = false,
  children,
  className,
  ...rest
}) => {
  return (
    <Typography
      variant="body2-regular"
      className={clsx(
        styles.message,
        styles[status || 'default'],
        showMessage ? styles.visible : styles.hidden,
        className
      )}
      {...rest}
    >
      {children}
    </Typography>
  )
}

export const ErrorMessage: FC<{
  className?: string
  children?: ReactNode
}> = (props) => {
  if (!props.children) {
    return null
  }

  return (
    <div className={clsx('fx gap-2', props.className)}>
      <Message showMessage status="error">
        {props.children}
      </Message>
    </div>
  )
}
